// extracted by mini-css-extract-plugin
export default {"DraggableVariationHandlerWrapper":"DraggableVariation_DraggableVariationHandlerWrapper__ahAGL","DraggableVariationHandler":"DraggableVariation_DraggableVariationHandler__DA8-g"};